const Feedback = ({ box }) => {
    const feedback = box.extra_feedback;
    const color = feedback ? 'is-dark' : '';

    return (
        <article className={`message ${color}`}>
            <div className="message-body">
                <span>{feedback ? feedback : 'No feedback left by customer.'}</span>
            </div>
        </article>
    );
};

export { Feedback };
